<template>
  <div class="num">
    <i></i>
    <span>{{ (watchNum + customWatchNum) | formatNum }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      customWatchNum: 0,
      watchNum: 0
    };
  },
  computed: {
    ...mapGetters({
      channelInfo: "channelInfo"
    })
  },
  watch: {
    "channelInfo.watchNum"(nVal) {
      this.changeWatchNum(nVal);
    }
  },
  mounted() {
    this.getNum();
    this.$Bus.$on("bus-customWatchNum", this.changeCustomWatchNum);
    this.$Bus.$on("bus-realWatchNum", this.changeWatchNum);
  },
  beforeDestroy() {
    this.$Bus.$off("bus-customWatchNum", this.changeCustomWatchNum);
    this.$Bus.$off("bus-realWatchNum", this.changeWatchNum);
  },
  methods: {
    async getNum() {
      this.customWatchNum = Number(this.channelInfo.customWatchNum || 0);
      this.watchNum = Number(this.channelInfo.watchNum || 0);
    },
    changeCustomWatchNum(num) {
      if (num) {
        this.customWatchNum += Number(num);
      }
    },
    changeWatchNum(num) {
      if (num) {
        this.watchNum = Number(num);
      }
    }
  },
};
</script>
<style lang="less" scoped>
.num {
  display: inline-block;
  margin-left: 5px;
  height: 20px;
  line-height: 20px;
  padding: 0 10px;
  border-radius: 20px;
  font-size: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;

  i {
    vertical-align: middle;
    display: inline-block;
    margin-right: 2px;
    width: 12px;
    height: 12px;
    background: url("./img/icon-watch-num.png") no-repeat center center;
    background-size: auto 100%;
  }
  span {
    vertical-align: middle;
    display: inline-block;
    font-size: 12px;
  }
}
</style>
